import React, { useState } from "react";
import TranslationDisplay from "../TranslationDisplay/TranslationDisplay";

const ReelHost = ({ configPath }) => {
  const [parentBackgroundColor, setParentBackgroundColor] = useState("#e5e7eb");

  const handleBackgroundColorChange = (suggestedColor) => {
    console.log("Suggested color:", suggestedColor);
    setParentBackgroundColor(suggestedColor);
  };

  return (
    <div
      className="w-full py-2 sm:py-4 px-4 overflow-x-hidden" // Responsive padding, prevent overflow
      style={{ backgroundColor: parentBackgroundColor }}
    >
      <div className="max-w-full sm:max-w-7xl mx-auto">
        {" "}
        {/* Full width on mobile */}
        <TranslationDisplay
          configPath={configPath}
          onBackgroundColorChange={handleBackgroundColorChange}
        />
      </div>
    </div>
  );
};

export default ReelHost;
